import { observer } from 'mobx-react-lite';
import { ComponentProps, ReactElement } from 'react';

export const CaretSortIcon = observer(
  (props: ComponentProps<'svg'>): ReactElement => (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <g>
        <path
          className='arrow-up'
          d='M5.55967 5.82444L8.26492 3.28661C8.67227 2.90446 9.3303 2.90446 9.73766 3.28661L12.4429 5.82444C13.1009 6.44175 12.6309 7.5 11.7013 7.5H6.29082C5.36122 7.5 4.90164 6.44175 5.55967 5.82444Z'
          fill='var(--joy-palette-neutral-400)'
        />
        <path
          className='arrow-down'
          d='M5.55967 12.1756L8.26492 14.7134C8.67227 15.0955 9.3303 15.0955 9.73766 14.7134L12.4429 12.1756C13.1009 11.5582 12.6309 10.5 11.7013 10.5H6.29082C5.36122 10.5 4.90164 11.5582 5.55967 12.1756Z'
          fill='var(--joy-palette-neutral-400)'
        />
      </g>
    </svg>
  )
);
